import { DateTime } from 'luxon'

import { LOCAL_24HOUR_FORMAT } from 'constants/formatting'

import { Event } from '@masaok/scanner-shared-next-public/types/event.types'

import {
  CANCELLED,
  COMPLETE,
  LEFT_EARLY,
  ON_DUTY,
  ON_TIME,
  SCHEDULED,
  ShiftStatus,
} from 'types/supabase.database.custom.types'

export const shouldStrikethrough = (now24: string, end24: string, shiftStatus: ShiftStatus) =>
  now24 >= end24 || shiftStatus === CANCELLED || shiftStatus === LEFT_EARLY

export const getShiftStatus = (
  inputDateTimeUtcIso: string,
  event: Event,
  shiftStatus: ShiftStatus
) => {
  // ON_DUTY is time-derived — never trust it from the DB without validating the time window.
  // All other explicit statuses (DELAYED, CANCELLED, LEFT_EARLY, ...) are shown as-is.
  if (shiftStatus && shiftStatus !== ON_TIME && shiftStatus !== ON_DUTY) return shiftStatus

  // Empty, ON_TIME, or ON_DUTY: derive state from the time window
  const now24 = DateTime.fromISO(inputDateTimeUtcIso).toFormat(LOCAL_24HOUR_FORMAT)
  const start24 = DateTime.fromISO(event.startISO).toFormat(LOCAL_24HOUR_FORMAT)
  const end24 = DateTime.fromISO(event.endISO).toFormat(LOCAL_24HOUR_FORMAT)

  if (end24 <= now24) return COMPLETE
  if (start24 <= now24 && now24 < end24) return ON_DUTY
  return SCHEDULED
}
